import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";

function MessageModalInfo({ close, showAnswer }) {
  return (
    <div className="AddnewsupportTicket relative">
      {" "}
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <p className=" text-[#77498F] text-[2rem] leading-[3.2rem] font-bold text-center mb-[5rem]">
        پیام
      </p>
      <div className=" mt-[5rem] max-w-[77rem]">
        <div className=" grid grid-cols-5 gap-x-[4.2rem] gap-y-[1.2rem]">
          <p className=" text-[#212121E5] font-bold text-[1.6rem] leading-[3.2rem]">
            عنوان پیام:
          </p>
          <p className="col-span-4 border border-solid py-[0.6rem] px-[1rem] border-[#9C5FA436] rounded-[1.5rem] text-[#21212199] font-normal text-[1.2rem] leading-[2.4rem] mr-[4.2rem] w-full">
            بررسی تکلیف
          </p>
          <p className=" text-[#212121E5] font-bold text-[1.6rem] leading-[3.2rem]">
            نام ارسال کننده:
          </p>
          <p className="col-span-4 border border-solid py-[0.6rem] px-[1rem] border-[#9C5FA436] rounded-[1.5rem] text-[#21212199] font-normal text-[1.2rem] leading-[2.4rem] mr-[4.2rem] w-full">
            علی رجبی
          </p>
          <p className=" text-[#212121E5] font-bold text-[1.6rem] leading-[3.2rem]">
            تاریخ ارسال:
          </p>
          <p className="col-span-4 border border-solid py-[0.6rem] px-[1rem] border-[#9C5FA436] rounded-[1.5rem] text-[#21212199] font-normal text-[1.2rem] leading-[2.4rem] mr-[4.2rem] w-full">
            یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵
          </p>
        </div>
        <div>
          <p className=" text-[#212121E5] font-bold text-[1.6rem] leading-[3.2rem]">
            متن پیام:
          </p>
          <p className="mt-[1rem] border border-solid py-[0.6rem] px-[1rem] border-[#9C5FA436] rounded-[1.5rem] text-[#21212199] font-normal text-[1.2rem] leading-[2.4rem] mr-[4.2rem] w-full">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز،
            و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای
            زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و
            متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان
            رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد
            کرد، در این صورت می توان امید داشت که تمام
          </p>
        </div>
      </div>
      <div className=" text-left mt-[5rem]">
        {" "}
        <BtnPrimary
          className="py-[20px] px-[25px]"
          text="پاسخ به این پیام"
          onClick={showAnswer}
        />
      </div>
    </div>
  );
}

export default MessageModalInfo;
